import React from "react";
import PropTypes from "prop-types";

const BigCardCurve = ({ height, width, fill, ...rest }) => {
  return (
    <svg
      width='208'
      height='38'
      viewBox='0 0 208 38'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 0.727051V37.3634H208V0.727051C176.215 13.6462 141.05 20.8766 104 20.8766C66.95 20.8766 31.7853 13.6462 0 0.727051Z'
        fill='white'
      />
    </svg>
  );
};

BigCardCurve.propTypes = {
  height: PropTypes.number,
  width: PropTypes.string,
  fill: PropTypes.string,
};

BigCardCurve.defaultProps = {
  height: 38,
  width: 208,
  fill: "#ffffff",
};

export default BigCardCurve;
